import Vue from 'vue'
import Timeago from '../core'
import { version } from 'vue-timeago/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.timeago = Timeago
Vue.$app.timeago.version = version
